// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__qPbZZ","percent":"style__percent__POuDq","progressRing":"style__progressRing__TgQse","circle":"style__circle__CsLwx","circleBg":"style__circleBg__eQOs+"};